<template>
  <div>
    <div class="content">

        <div class="content__top"   data-v-step="1">

              <!-- <div class="ghost-button outline-border outline-shadow" v-tooltip="tooltip_msg" tabindex="0">
                  <div class="show-me">i</div>
              </div> -->

            <h2 v-if="post.content" v-html="post.title.rendered"></h2>
        </div>

          <div class="canvas__holder" :class="{ colorize: has_colorize }">
              <div class="spinner__holder">
                <span class="icon-spinner" :class="[ this.showCanvasCircle ? 'opacity__show' : 'opacity__hide']" v-html="spinner" :style="{ transform:'rotate(' + sliderValue + 'deg)' }"></span>
              </div>
              <canvas ref="canvas" id="canvas" width="894" height="550" :class="{ colorize: has_colorize }" ></canvas>
          </div>

          <div class="content__slider" id="content-slider">
            <div class="slider__holder">
                <vue-slider ref="slider" v-model="sliderValue" :tooltip-formatter="formatter" @drag-end="sliderDragEnd" @drag-start="sliderDragStart" v-bind="options" :marks="marks" data-v-step="3">
                  <template v-slot:dot>
                      <svg height="44" viewBox="0 0 26 44" width="26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <linearGradient id="grad" x1="45.792595%" x2="55.595567%" y1="0%" y2="100%">
                            <stop offset="0" stop-color="#ff9200"/>
                            <stop offset="1" stop-color="#ff5900"/>
                          </linearGradient>
                        <path d="m669.732129 1085.96282 8-11.33334c1.273973-1.80479 3.769808-2.23511 5.574604-.96113.372866.2632.697938.58827.961138.96113l8 11.33334c.476377.67486.732129 1.48067.732129 2.30673v22.73045c0 2.20914-1.790861 4-4 4h-16c-2.209139 0-4-1.79086-4-4v-22.73045c0-.82606.255752-1.63187.732129-2.30673z" fill="url(#grad)" fill-rule="evenodd" stroke="url(#grad)" stroke-width="2" transform="translate(-668 -1072)"/>
                      </svg>
                  </template>
                </vue-slider>
            </div>
            

            <!-- <div class="ghost-button outline-border outline-shadow" v-tooltip="info_button" tabindex="0">
                <div class="show-me">i</div>
            </div> -->
          </div>
          <div class="contrast_msg">* {{contrast_msg}}</div>

           <!-- <div class="slider__holder">
                <vue-slider ref="slider2" v-model="someValue" v-bind="sliderOptions2" :marks="marks2" >
                  <template v-slot:dot>
                      <svg height="44" viewBox="0 0 26 44" width="26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <linearGradient id="grad" x1="45.792595%" x2="55.595567%" y1="0%" y2="100%">
                            <stop offset="0" stop-color="#ff9200"/>
                            <stop offset="1" stop-color="#ff5900"/>
                          </linearGradient>
                        <path d="m669.732129 1085.96282 8-11.33334c1.273973-1.80479 3.769808-2.23511 5.574604-.96113.372866.2632.697938.58827.961138.96113l8 11.33334c.476377.67486.732129 1.48067.732129 2.30673v22.73045c0 2.20914-1.790861 4-4 4h-16c-2.209139 0-4-1.79086-4-4v-22.73045c0-.82606.255752-1.63187.732129-2.30673z" fill="url(#grad)" fill-rule="evenodd" stroke="url(#grad)" stroke-width="2" transform="translate(-668 -1072)"/>
                      </svg>
                  </template>
                </vue-slider>
            </div> -->
            <!-- <div class="content__slider" >
            <div class="slider__holder">
                <vue-slider ref="slider3" v-model="polarizationContrast" v-bind="sliderOptions2" :marks="marks2" >
                  <template v-slot:dot>
                      <svg height="44" viewBox="0 0 26 44" width="26" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                          <linearGradient id="grad" x1="45.792595%" x2="55.595567%" y1="0%" y2="100%">
                            <stop offset="0" stop-color="#ff9200"/>
                            <stop offset="1" stop-color="#ff5900"/>
                          </linearGradient>
                        <path d="m669.732129 1085.96282 8-11.33334c1.273973-1.80479 3.769808-2.23511 5.574604-.96113.372866.2632.697938.58827.961138.96113l8 11.33334c.476377.67486.732129 1.48067.732129 2.30673v22.73045c0 2.20914-1.790861 4-4 4h-16c-2.209139 0-4-1.79086-4-4v-22.73045c0-.82606.255752-1.63187.732129-2.30673z" fill="url(#grad)" fill-rule="evenodd" stroke="url(#grad)" stroke-width="2" transform="translate(-668 -1072)"/>
                      </svg>
                  </template>
                </vue-slider>
            </div>
            <div class="ghost-button outline-border outline-shadow" v-tooltip="info_button2">
                <div class="show-me">i</div>
            </div>
          </div> -->


      <div v-if="post.content" v-html="post.content.rendered" data-v-step="5"></div>

    </div>

      <v-tour name="pTour" :steps="tourSteps" :options="tourOptions" :callbacks="tourCallbacks">
        <template slot-scope="tour">
          <transition name="fade" >
            <v-step
              v-if="tour.currentStep === index"
              v-for="(step, index) of tour.steps"
              :key="index"
              :step="step"
              :previous-step="tour.previousStep"
              :next-step="tour.nextStep"
              :stop="tour.stop"
              :is-first="tour.isFirst"
              :is-last="tour.isLast"
              :labels="tour.labels"
            >
              <template>
                <div slot="actions" >
                  <button @click="tour.stop" v-if="!tour.isLast" class="v-step__button">{{labels.buttonSkip}}</button>
                  <button @click="tour.previousStep" v-if="!tour.isFirst" class="v-step__button">{{labels.buttonPrevious}}</button>
                  <button @click="tour.nextStep" v-if="!tour.isLast" class="v-step__button">{{labels.buttonNext}}</button>
                  <button @click="tour.stop" v-if="tour.isLast" class="v-step__button">{{labels.buttonStop}}</button>
                </div>
              </template>
            </v-step>
          </transition>
        </template>
      </v-tour>


  </div>
</template>

<script>
import axios     from "axios"
import {i18n}    from './plugins/i18n.js'
import vueSlider from 'vue-slider-component'

var postid =  document.getElementById("featured_post_id").value;
// var tolip = this.post.acf.tooltip_message;


export default {
  components: {
      'vueSlider': vueSlider,

  },
  data() {
    return {


      // Wordpress Posts Endpoint
      postUrl: "/wp-json/wp/v2/imageset/",
      // Returned Posts in an Array
      post: [],
      queryOptions: {
        _embed: true
      },

      firstVisit : true,

      has_colorize: null,
      tooltip_msg: null,
      generated: null,
      showCanvasCircle: false,

      spinner: window.spinner,
      contrast_msg: window.p_contrast_msg,
      evpa: 180,

      ////////////

      displayed_ctx:null,

      ctx_I:null,
      ctx_Q:null,
      ctx_U:null,

      loaded_I: false,
      loaded_Q: false,
      loaded_U: false,

      images_loaded_interval: null,


      /////



      info_button: i18n.t('info_button_slider'),
      info_button2: i18n.t('info_button_contrast'),
      //Slider stuff
      sliderValue: 180,
      marks:{
        '0':{
          label: '0°',
        },
        '180': {
          label: '180°',
        },
        '360':{
          label: '360°',
        },
      },
      formatter: '{value}°',
      options: {
        dotSize: 14,
        width: 'auto',
        height: 4,
        contained: false,
        direction: 'ltr',
        dataLabel: 'label',
        dataValue: 'sliderValue',
        min: 0,
        max: 360,
        interval: 1,
        disabled: false,
        clickaboptionsle: true,
        duration: 0.5,
        adsorb: false,
        lazy: false,
        tooltip: 'active',
        tooltipPlacement: 'top',
        tooltipFormatter: void 0,
        useKeyboard: true,
        keydownHook: null,
        dragOnClick: false,
        enableCross: true,
        fixed: false,
        minRange: void 0,
        maxRange: void 0,
        order: true,
        marks: false,
        dotOptions: void 0,
        dotAttrs: void 0,
        process: true,
        dotStyle: void 0,
        railStyle: void 0,
        processStyle: void 0,
        tooltipStyle: void 0,
        stepStyle: void 0,
        stepActiveStyle: void 0,
        labelStyle: void 0,
        labelActiveStyle: void 0,
      },

      //////
      polarizationContrast:0,
      p_c:1,

      ////
      // someValue: 50,
      s:0.5,

      marks2:{
        '0':{
          label: '0°',
        },
        '100':{
          label: '100',
        },
      },

      // sliderOptions2:{
      //   dotSize: 14,
      //   width: 'auto',
      //   height: 4,
      //   contained: false,
      //   direction: 'ltr',
      //   dataLabel: 'label',
      //   dataValue: 'polarizationContrast',
      //   min: 0,
      //   max: 100,
      //   interval: 1,
      //   disabled: false,
      //   clickable: true,
      //   duration: 0.5,
      //   adsorb: false,
      //   lazy: false,
      //   tooltip: 'active',
      //   tooltipPlacement: 'top',
      //   tooltipFormatter: void 0,
      //   useKeyboard: false,
      //   keydownHook: null,
      //   dragOnClick: true,
      //   enableCross: true,
      // },

      tourCallbacks: {
        onStop: this.tourStop,
      },
      tourOptions: {
        useKeyboardNavigation: true
      },
      labels: {
        buttonSkip: i18n.t('tour_skip'),
        buttonPrevious: i18n.t('tour_prev'),
        buttonNext: i18n.t('tour_next'),
        buttonStop: i18n.t('tour_finish')
      },
      tourSteps: [

        {
          target: '[data-v-step="1"]',  // We're using document.querySelector() under the hood
          content: i18n.t('tour_step1'),
          params: {
            placement: 'top',
            enableScrolling: true
          },
          offset: -450
        },
        {
          target: '[data-v-step="2"]',  // We're using document.querySelector() under the hood
          content: i18n.t('tour_step2'),
          params: {
            placement: 'top',
            enableScrolling: true
          },
          offset: -500
        },
        {
          target: '[data-v-step="3"]',  // We're using document.querySelector() under the hood
          content: i18n.t('tour_step3'),
          params: {
            placement: 'top',
            enableScrolling: true
          },
          offset: -500
        },
        // {
        //   target: '[data-v-step="4"]',  // We're using document.querySelector() under the hood
        //   content: i18n.t('tour_step4'),
        //   params: {
        //     placement: 'top',
        //     enableScrolling: false
        //   }
        // },
        {
          target: '[data-v-step="5"]',  // We're using document.querySelector() under the hood
          content: i18n.t('tour_step5'),
          params: {
            placement: 'top',
            enableScrolling: true
          },
          offset: -500
        },
        {
          target: '[data-v-step="6"]',  // We're using document.querySelector() under the hood
          content: i18n.t('tour_step6'),
          params: {
            placement: 'bottom',
            enableScrolling: true
          },
          offset: -50
        }
      ],
    };
  },

  created() {
    var tour = this
    jQuery(document).on('click', '#help-me-button', function(){
            tour.$tours['pTour'].start()
    })
    jQuery(document).on('keypress', '#help-me-button', function(e){
        if(e.keyCode === 13){
            tour.$tours['pTour'].start()
        }
    })
  },

  mounted() {

    this.displayed_ctx = this.$refs.canvas.getContext("2d");

    this.getPost(postid);

    if(this.$cookie.get('vue_tour_seen')){
          this.firstVisit =  false;
    }else{
          this.startTour();
    }

    this.$watch(
        () => {
            return this.$refs.slider.dots[0].focus
        },
      (val) => {
        // alert('$watch $refs.<name>.<data>: ' + val)
        this.showCanvasCircle = val
      }
    )

  },

  watch: {
      sliderValue : function(val){
        // console.log(this.p_c)
        var radian =  val * 0.0174532925199
        this.generate_ipol(radian, this.s, this.p_c)
      },
      // someValue : function(val){

      //   this.s = val/100
      //   var radian =  this.sliderValue * 0.0174532925199
      //   console.log('radian', radian)
      //   this.generate_ipol(radian, this.s)
      // },

      // polarizationContrast : function(val){
      //
      //   this.p_c = val/10
      //   var radian =  this.sliderValue * 0.0174532925199
      //   this.generate_ipol(radian, this.s, this.p_c)
      // }
  },

  methods: {
    getPost(postid) {

      this.clearImages();
      this.has_colorize = false;
      axios
        .get(this.postUrl+postid, { params: this.queryOptions })
        .then(response => {

          this.sliderValue = 180;
          this.evpa = 180;
          this.post = response.data;

          /// if images is b&w add red background

          this.has_colorize = this.post.acf.colorize_red;
          this.tooltip_msg = this.post.acf.tooltip_message;

          /// images need IQU calculated
          // this.needsIQU = this.post.acf.generated;

          ///need a this reference for onLoad functions
          const self = this

          let image_I = new Image()
          let image_Q = new Image()
          let image_U = new Image()

          image_I.src = response.data.acf.images.image_1.sizes.canvas
          image_Q.src = response.data.acf.images.image_2.sizes.canvas
          image_U.src = response.data.acf.images.image_3.sizes.canvas
          this.p_c    = response.data.acf.polarization_constrast

          let canvas_I = document.createElement("canvas")
          let canvas_Q = document.createElement("canvas")
          let canvas_U = document.createElement("canvas")

          canvas_I.width  = canvas_Q.width  = canvas_U.width  = canvas.width
          canvas_I.height = canvas_Q.height = canvas_U.height = canvas.height

          this.ctx_I = canvas_I.getContext("2d")
          this.ctx_Q = canvas_Q.getContext("2d")
          this.ctx_U = canvas_U.getContext("2d")

          image_I.addEventListener('load', (event) => {
            // self.displayed_ctx.drawImage(image_I, 0 ,0, canvas.width, canvas.height)
            self.ctx_I.drawImage(image_I, 0, 0, canvas.width, canvas.height)
            self.loaded_I = true
          });

          image_Q.addEventListener('load', (event) => {
            self.ctx_Q.drawImage(image_Q, 0, 0, canvas.width, canvas.height)
            self.loaded_Q = true
          });

          image_U.addEventListener('load', (event) => {
            self.ctx_U.drawImage(image_U, 0, 0, canvas.width, canvas.height)
            self.loaded_U = true
          });
          
          if(response.data.acf.generated == 'cam'){
            this.s = 0
            this.images_loaded_interval = setInterval(this.generateIQU, 50);
          }else{
            this.s = 0.6            
            this.images_loaded_interval = setInterval(this.fistRender, 50);
          }          

        })
        .catch(error => {
          console.log(error);
        });
    },

    clearImages(){
        this.displayed_ctx.clearRect(0, 0, canvas.width, canvas.height);
        if(this.ctx_I){
          this.ctx_I.clearRect(0, 0, canvas.width, canvas.height);
          this.ctx_Q.clearRect(0, 0, canvas.width, canvas.height);
          this.ctx_U.clearRect(0, 0, canvas.width, canvas.height);
        }
        this.loaded_I = false;
        this.loaded_Q = false;
        this.loaded_U = false;
    },

    fistRender(){
      if(this.loaded_I && this.loaded_Q && this.loaded_U){
        clearInterval(this.images_loaded_interval);
        this.generate_ipol(3.141592653582, this.s, this.p_c)
      }
    },

    generate_ipol(evpa, s, p_c=1) {

      console.log(evpa, s, p_c)
      const imageData = this.displayed_ctx.getImageData(0, 0, canvas.width, canvas.height);
      const data = imageData.data;

      const I = this.ctx_I.getImageData(0, 0, canvas.width, canvas.height).data;
      const Q = this.ctx_Q.getImageData(0, 0, canvas.width, canvas.height).data;
      const U = this.ctx_U.getImageData(0, 0, canvas.width, canvas.height).data;

      // Add polarization contrast same as python code

      p_c = (p_c/100) + 1;  //convert to decimal & shift range: [0..2]
      var intercept = 128 * (1 - p_c);

      /// r,g,b, (alpha )
      /// equivalent of get_polarized_flux (avery phyton) : Ipol = 0.5*( I + np.cos(2.0*evpa)*Q - np.sin(2.0*evpa)*U )
      for(var i = 0; i < data.length; i += 4){
        data[i]     = (0.5  * ((I[i]     / 255.0) + Math.cos(2.0 * evpa) * ((Q[i]     / 255.0) - s)  - Math.sin(2.0 * evpa) * ((U[i]     / 255.0) - s) )) * 255 * p_c + intercept //red
        data[i + 1] = (0.5  * ((I[i + 1] / 255.0) + Math.cos(2.0 * evpa) * ((Q[i + 1] / 255.0) - s)  - Math.sin(2.0 * evpa) * ((U[i + 1] / 255.0) - s) )) * 255 * p_c + intercept //green
        data[i + 2] = (0.5  * ((I[i + 2] / 255.0) + Math.cos(2.0 * evpa) * ((Q[i + 2] / 255.0) - s)  - Math.sin(2.0 * evpa) * ((U[i + 2] / 255.0) - s) )) * 255 * p_c + intercept //blue
        data[i + 3] = 255
      }
      
      this.displayed_ctx.putImageData(imageData, 0, 0)
    },

    sliderDragStart(){
      this.showCanvasCircle = 1
    },
    sliderDragEnd(){
      this.$refs.slider.dots[0].blur
      this.showCanvasCircle = 0
    },
    //Takes I0, Ip, Im  (I measured with a polaroid at 0, 120, and 240 degrees, respectively)
    generateIQU(){

      if(this.loaded_I && this.loaded_Q && this.loaded_U){
        clearInterval(this.images_loaded_interval);

        const I0 = this.ctx_I.getImageData(0, 0, canvas.width, canvas.height)
        const Ip = this.ctx_Q.getImageData(0, 0, canvas.width, canvas.height)
        const Im = this.ctx_U.getImageData(0, 0, canvas.width, canvas.height)

        ///////
        let data_I0 = I0.data;
        let data_Ip = Ip.data;
        let data_Im = Im.data;

        const c_array_I0 = new Uint8ClampedArray(data_I0.length)
        const c_array_Ip = new Uint8ClampedArray(data_Ip.length)
        const c_array_Im = new Uint8ClampedArray(data_Im.length)

        //generate I
        for(var i = 0; i < data_I0.length; i += 4){

          // c_array_I0[i]     = (2.0/3.0 * (data_I0[i]     / 255.0 + data_Ip[i]      / 255.0 + data_Im[i]     / 255.0)) * 255
          // c_array_I0[i + 1] = (2.0/3.0 * (data_I0[i + 1] / 255.0 + data_Ip[i + 1]  / 255.0 + data_Im[i + 1] / 255.0)) * 255
          // c_array_I0[i + 2] = (2.0/3.0 * (data_I0[i + 2] / 255.0 + data_Ip[i + 2]  / 255.0 + data_Im[i + 2] / 255.0)) * 255
          // c_array_I0[i + 3] = 255

            // c_array_I0[i]     = (2.0/3.0 * (data_I0[i]     / 255.0 + data_Ip[i]      / 255.0 + data_Im[i]     / 255.0)) * 255
            // c_array_I0[i + 1] = (2.0/3.0 * (data_I0[i + 1] / 255.0 + data_Ip[i + 1]  / 255.0 + data_Im[i + 1] / 255.0)) * 255
            // c_array_I0[i + 2] = (2.0/3.0 * (data_I0[i + 2] / 255.0 + data_Ip[i + 2]  / 255.0 + data_Im[i + 2] / 255.0)) * 255
            // c_array_I0[i + 3] = 255

            c_array_I0[i]     = data_I0[i]
            c_array_I0[i + 1] = data_I0[i + 1]
            c_array_I0[i + 2] = data_I0[i + 2]
            c_array_I0[i + 3] = 255
        }
        // console.log(this.toImageData(c_array_I0))
        // this.ctx_I.clearRect(0, 0, canvas.width, canvas.height)
        this.ctx_I.putImageData(this.toImageData(c_array_I0) ,0,0)
        // this.displayed_ctx.putImageData(this.toImageData(c_array_I0) ,0,0)
        //generate Q

        for(var i = 0; i < data_Ip.length; i += 4){

          c_array_Ip[i]     = (-2.0/3.0 * (data_Ip[i]     / 255.0 - 2 *  data_I0[i]      / 255.0 + data_Im[i]     / 255.0)) * 255
          c_array_Ip[i + 1] = (-2.0/3.0 * (data_Ip[i + 1] / 255.0 - 2 *  data_I0[i + 1]  / 255.0 + data_Im[i + 1] / 255.0)) * 255
          c_array_Ip[i + 2] = (-2.0/3.0 * (data_Ip[i + 2] / 255.0 - 2 *  data_I0[i + 2]  / 255.0 + data_Im[i + 2] / 255.0)) * 255
          c_array_Ip[i + 3] = 255;
        }
        // this.ctx_Q.clearRect(0, 0, canvas.width, canvas.height)
        this.ctx_Q.putImageData(this.toImageData(c_array_Ip) ,0,0)

        //generate U
        for(var i = 0; i < data_Im.length; i += 4){

          c_array_Im[i]     = (-2.0/Math.sqrt(3.0) * (data_Ip[i]          / 255.0 - data_Im[i]         / 255.0)) * 255
          c_array_Im[i + 1] = (-2.0/Math.sqrt(3.0) * (data_Ip[i + 1]      / 255.0 - data_Im[i + 1]     / 255.0)) * 255
          c_array_Im[i + 2] = (-2.0/Math.sqrt(3.0) * (data_Ip[i + 2]      / 255.0 - data_Im[i + 2]     / 255.0)) * 255
          c_array_Im[i + 3] = 255;
        }
        // this.ctx_U.clearRect(0, 0, canvas.width, canvas.height)
        this.ctx_U.putImageData(this.toImageData(c_array_Im) ,0,0)

        // this.displayed_ctx.putImageData(this.toImageData(c_array_Im), 0, 0)       
        this.generate_ipol(3.141592653582, this.s, this.p_c)
      }
    },

    toImageData(clampedArray){
      return new ImageData(clampedArray, canvas.width, canvas.height)
    },

    startTour(){
          this.$tours['pTour'].start();
    },
    tourStop (step) {
          this.$cookie.set('vue_tour_seen', true);
    }
  }
}
</script>
